import type { ActionIconProps } from '@mantine/core';
import { AddRowButton } from '@vision/ui/components/RowActions/AddRowButton';

export interface KeyValuePairInputAddButtonProps {
  disabled: boolean;
  handleAddPair: () => void;
  addButtonProps: ActionIconProps;
  // The accessible name of the icon-only button.
  label: string;
}

export function KeyValuePairInputAddButton({
  disabled,
  handleAddPair,
  addButtonProps,
  label,
}: KeyValuePairInputAddButtonProps) {
  return (
    <AddRowButton
      label={label}
      data-testid="button-add-key-value-pair"
      disabled={disabled}
      onClick={handleAddPair}
      {...addButtonProps}
    />
  );
}
